const actionTypeIdentifier = '7DBAD149-D061-4AAE-95C8-7628B7B7E004'; // to generate open ssms run select newid()

//location form actions
export const resetWirelessChangeVendorForm = `RESET-WIRELESS-CHANGE-VENDOR-FORM-${actionTypeIdentifier}`;
export const setUserLocation = `SET-WIRELESS-CHANGE-VENDOR-USER-LOCATION-${actionTypeIdentifier}`;
export const setVendorOptions = `SET-WIRELESS-CHANGE-VENDOR-VENDOR-OPTIONS-${actionTypeIdentifier}`;
export const setAccountOptions = `SET-WIRELESS-CHANGE-VENDOR-ACCOUNT-OPTIONS-${actionTypeIdentifier}`;
export const setPlanOptions = `SET-WIRELESS-CHANGE-VENDOR-PLAN-OPTIONS-${actionTypeIdentifier}`;
export const setOtherPlanOptions = `SET-WIRELESS-CHANGE-VENDOR-PLAN-OTHER-PLANS-OPTIONS-${actionTypeIdentifier}`;
export const setSimOptions = `SET-WIRELESS-CHANGE-VENDOR-SIM-OPTIONS-${actionTypeIdentifier}`;
export const setOrderOptions = `SET-WIRELESS-CHANGE-VENDOR-ORDER-OPTIONS-${actionTypeIdentifier}`;
export const setCountryOptions = `SET-WIRELESS-CHANGE-VENDOR-COUNTRY-OPTIONS-${actionTypeIdentifier}`;
export const setDeviceOptions = `SET-WIRELESS-CHANGE-VENDOR-DEVICE-OPTIONS-${actionTypeIdentifier}`;
export const setAddressOptions = `SET-WIRELESS-CHANGE-VENDOR-ADDRESS-OPTIONS-${actionTypeIdentifier}`;
export const setVendorDetails = `SET-WIRELESS-CHANGE-VENDOR-VENDOR-DETAILS-${actionTypeIdentifier}`;
export const setPlanDetails = `SET-WIRELESS-CHANGE-VENDOR-PLAN-DETAILS-${actionTypeIdentifier}`;
export const setSubscriptionDetails = `SET-WIRELESS-CHANGE-VENDOR-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setServiceTypeDetails = `SET-WIRELESS-CHANGE-VENDOR-SERVICE-TYPE-DETAILS-${actionTypeIdentifier}`;
export const setPurposeOfUseDetail = `SET-WIRELESS-CHANGE-PURPOSE-OF-USE-DETAILS-${actionTypeIdentifier}`;
export const setShowDeviceOptions = `SET-WIRELESS-CHANGE-VENDOR-SHOW-DEVICE-OPTIONS-${actionTypeIdentifier}`;
export const setBusinessCaseOptions = `SET-WIRELESS-CHANGE-VENDOR-BUSINESS-CASE-OPTIONS-${actionTypeIdentifier}`;
export const setPurposeOfUseOptions = `SET-WIRELESS-CHANGE-VENDOR-PURPOSE-OF-USE-OPTIONS-${actionTypeIdentifier}`;
export const setDeviceAccessories = `SET-WIRELESS-CHANGE-VENDOR-DEVICE-ACCESSORIES-${actionTypeIdentifier}`;
export const setShowPreferredAddress = `SET-WIRELESS-CHANGE-VENDOR-SHOW-PREFERRED-ADDRESS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELESS-CHANGE-VENDOR-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const setCircuitTypeDetail = `SET-WIRELESS-CHANGE-VENDOR-CIRCUIT-TYPE-DETAILS-${actionTypeIdentifier}`;
export const setCircuitType = `SET-WIRELESS-CHANGE-VENDOR-CIRCUIT-TYPES-${actionTypeIdentifier}`;
export const setResetLoading = `SET-WIRELESS-CHANGE-VENDOR-RESET-LOADING-${actionTypeIdentifier}`;

export const setCountryLoading = `SET-COUNTRY-LOADING-${actionTypeIdentifier}`;
export const setAddressLoading = `SET-ADDRESS-LOADING-${actionTypeIdentifier}`;
export const setVendorLoading = `SET-VENDOR-LOADING-${actionTypeIdentifier}`;
export const setCircuitTypesLoading = `SET-CIRCUIT-TYPES-LOADING-${actionTypeIdentifier}`;
export const setMobServiceTypeLoading = `SET-MOB-SERVICE-TYPE-LOADING-${actionTypeIdentifier}`;
export const setPlanOptionLoading = `SET-PLAN-OPTION-LOADING-${actionTypeIdentifier}`;

export const wirelessChangeVendorModel = {
    circuitCode: ''
    , circuitId: 0
    , newVendorId: ''
    , orderOptionId: 0
    , equipmentInventoryId: 0
    , newAccountId: 0
    , newPlanId: 0
    , newSimTypeId: 0
    , planDetailsModel: []
    , mobileServiceModel: []
    , accessoryDetailsModel: []
    , countryCode: ''
    , country: ''
    , locationId: ''
    , otherDeliveryAddress: ''
    , deliveryAddress: ''
    , circuitTypeId: ''
    , planComponentList: []
}
